export const PRX_SALES_REP_LABEL = 'PRX Sales Rep';

/**
 * POM-6494: the order partner's current internal Sales User. An unassigned partner reads
 * "Not assigned"; a lookup that failed reads "Unavailable", so an error is never shown as
 * unassigned. undefined means the order has not loaded it yet.
 */
const formatPrxSalesRep = (prxSalesRep) => {
  if (prxSalesRep === undefined) {
    return undefined;
  }

  if (!prxSalesRep) {
    return 'Not assigned';
  }

  if (prxSalesRep.unavailable || !prxSalesRep.firstName) {
    return 'Unavailable';
  }

  return `${prxSalesRep.firstName} ${prxSalesRep.lastName ?? ''}`.trim();
};

export default formatPrxSalesRep;
